module.exports = __webpack_public_path__ + "img/20190615104337QQ截图20190612162729.b4d5b81c.png";